import { ReactNode } from 'react'

import useBriefZone from './useBriefZone'

interface BriefZoneProps {
  children: ReactNode
}

const BriefZone = (props: BriefZoneProps) => {
  const { children } = props
  const {} = useBriefZone()

  return <>{children}</>
}

export default BriefZone
